var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHungry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 103,
    viewBox: "0 0 102 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lzvm47ixaa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.078 102.387H18.961l1.076-5.241a10.909 10.909 0 0 1 10.687-8.716h20.591a10.91 10.91 0 0 1 10.687 8.716l1.076 5.241z",
    fill: "#90DFC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.902 88.43c-.46 0-.909.08-1.344.237-2.48.883-4.476 4.163-5.003 8.479l-.64 5.241H18.96l1.076-5.241a10.909 10.909 0 0 1 10.687-8.716h4.18z",
    fill: "#66B49D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.122 78.238v10.193a6.103 6.103 0 0 1-12.208 0V78.238h12.208z",
    fill: "#FFCBBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.011 94.201a6.104 6.104 0 0 1-8.097-5.77V78.238H38.9v10.193a6.103 6.103 0 0 0 4.112 5.77z",
    fill: "#EAAC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.914 78.238h12.208v9.39H34.914v-9.39z",
    fill: "#EAAC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.626 52.2-2.067 9.574-55.078 3.73c-4.457-8.878-14.926-28.83 1.41-41.09 12.572-9.437 28.5-6.062 28.5-6.062S69.54 4.877 66.625 52.2z",
    fill: "#544F57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.427 56.13-8.54 17.19-5.406-7.816c-4.457-8.878-14.926-28.829 1.41-41.09 12.572-9.437 28.5-6.061 28.5-6.061-26.413 6.14-22.71 29.357-15.964 37.778z",
    fill: "#454045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.78 77.155a7.968 7.968 0 0 1-9.774-7.718c-.03-4.693 6.704-5.487 7.767-.916l49.67-11.546c-1.062-4.571 5.332-6.828 7.375-2.604a7.968 7.968 0 0 1-5.368 11.237",
    fill: "#EAAC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.344 72.518c-.364 0-.73-.129-1.023-.39a4.15 4.15 0 0 0-1.086-.648c-.903-.353-1.337-.047-1.5.067a1.54 1.54 0 0 1-1.77-2.52c1.29-.905 2.89-1.036 4.506-.368a7.165 7.165 0 0 1 1.903 1.175 1.539 1.539 0 0 1-1.03 2.684zM64.016 60.97a1.54 1.54 0 0 1-1.428-2.112c.04-.101.42-1.02 1.19-1.893 1.154-1.312 2.647-1.901 4.205-1.657a1.54 1.54 0 1 1-.476 3.041c-1.283-.202-2.055 1.636-2.062 1.654a1.54 1.54 0 0 1-1.43.968z",
    fill: "#DF9380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.615 49.114 2.943 12.66c2.324 9.995-3.896 19.984-13.893 22.309l-13.469 3.13C27.2 89.537 17.211 83.316 14.887 73.32l-2.86-12.304c3.693-1.407 7.59-3.042 11.4-4.886 9.237-4.466 17.979-10.166 22.143-16.853 0 0 6.102 10.644 16.045 9.837z",
    fill: "#FFCBBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.089 84.45-11.893 2.764c-9.996 2.324-19.985-3.897-22.309-13.893l-2.86-12.304c3.693-1.407 7.59-3.043 11.4-4.886l3.353 14.425c2.323 9.996 12.31 16.218 22.309 13.894z",
    fill: "#EAAC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.766 74.546a6.774 6.774 0 0 1-5.488-2.806 1.54 1.54 0 0 1 2.492-1.807 3.702 3.702 0 0 0 3.842 1.436 3.702 3.702 0 0 0 2.815-2.983 1.539 1.539 0 1 1 3.034.522 6.774 6.774 0 0 1-5.152 5.46 6.814 6.814 0 0 1-1.543.178z",
    fill: "#DD636E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.199 67.926c2.245-.52 3.808-2.05 3.492-3.415-.317-1.365-2.394-2.05-4.64-1.528-2.245.52-3.808 2.05-3.491 3.415.317 1.365 2.393 2.05 4.639 1.528zM25.937 74.715c2.245-.52 3.809-2.05 3.492-3.415-.317-1.365-2.394-2.05-4.64-1.528-2.244.52-3.808 2.05-3.49 3.415.316 1.365 2.393 2.05 4.638 1.528z",
    fill: "#E490B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.648 66.825a1.54 1.54 0 0 1-.348-3.039l4.837-1.124a1.539 1.539 0 1 1 .697 2.998l-4.837 1.124c-.117.028-.234.04-.35.04z",
    fill: "#EAAC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.639 68.397a1.539 1.539 0 0 1-1.53-1.723 7.39 7.39 0 0 1 5.308-6.235 7.39 7.39 0 0 1 7.807 2.471 1.54 1.54 0 0 1-2.397 1.933 4.317 4.317 0 0 0-4.56-1.445 4.317 4.317 0 0 0-3.102 3.643 1.54 1.54 0 0 1-1.526 1.356zM45.41 61.29a1.54 1.54 0 0 1-1.53-1.723 7.39 7.39 0 0 1 5.308-6.235 7.39 7.39 0 0 1 7.807 2.471 1.54 1.54 0 0 1-2.397 1.932 4.318 4.318 0 0 0-4.56-1.444 4.317 4.317 0 0 0-3.101 3.643 1.54 1.54 0 0 1-1.527 1.355z",
    fill: "#DF9380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.57 37.11c12.91 0 23.376-8.22 23.376-18.36C99.946 8.608 89.481.388 76.571.388s-23.376 8.22-23.376 18.36c0 10.14 10.466 18.36 23.376 18.36zM68.844 47.86a3.562 3.562 0 1 0 0-7.124 3.562 3.562 0 0 0 0 7.125z",
    fill: "#D0E2E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.057 23.148H69.68a2.912 2.912 0 1 0 0 5.824h14.377a2.912 2.912 0 1 0 0-5.824z",
    fill: "#F4DD45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.854 28.12a2.906 2.906 0 0 0 2.06.853H69.68a2.905 2.905 0 0 1-2.059-.854 2.896 2.896 0 0 1-.853-2.058 2.912 2.912 0 0 1 2.912-2.91h7.234a2.911 2.911 0 0 0-2.06 4.968z",
    fill: "#EAB14D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.057 17.326H69.68a2.912 2.912 0 1 0 0 5.824h14.377a2.912 2.912 0 1 0 0-5.824z",
    fill: "#B16E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.718 22.295a2.904 2.904 0 0 0 2.059.854H69.68a2.898 2.898 0 0 1-2.059-.854 2.911 2.911 0 0 1 2.059-4.97h7.097a2.913 2.913 0 0 0-2.059 4.97z",
    fill: "#985E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.924 7.498h-8.111a6.045 6.045 0 0 0-6.045 6.045 3.783 3.783 0 0 0 3.782 3.783h12.636a3.783 3.783 0 0 0 3.783-3.783 6.045 6.045 0 0 0-6.045-6.045z",
    fill: "#F4DD45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.11 16.216a3.764 3.764 0 0 0 2.674 1.109H70.55a3.763 3.763 0 0 1-2.674-1.109 3.763 3.763 0 0 1-1.108-2.674 6.046 6.046 0 0 1 6.046-6.046h7.234a6.046 6.046 0 0 0-6.046 6.046c0 1.045.423 1.991 1.108 2.674z",
    fill: "#EAB14D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lzvm47ixaa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .389)",
    d: "M0 0h102v102H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHungry);
export default __webpack_public_path__ + "static/media/hungry.c645f8c931627acfe71ef5d57f8dd1f3.svg";
export { ForwardRef as ReactComponent };